<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray">
		<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
				{{this.$t("212")}}
			</div>
		</div>
		<div class="divider"></div>
		<!-- subtabs -->
		<TopAppBarSurveyListTab></TopAppBarSurveyListTab>
		<NoData v-if="isNoData"></NoData>
		<div class="container pdt-30" v-if="isNoData==false">
			<!-- <div class="mgb-30" v-if="isNoData===false && campaignData && campaignData.locationValue === null">
				<a v-if="campaignData.dynamicLink && campaignData.image" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 survey-banner">
				</a>
			</div>
			<div :class="campaignData && campaignData.image ? 'mgb-30' : ''" v-else>
				<a href="javascript:void(0)" v-if="campaignData && campaignData.image" style="cursor:none" >
					<img :src="campaignData.image" alt="" class="b-radius4 survey-banner" />
				</a>
			</div> -->
				<div class="d-flex justify-content-between">
						<div class="t-body6 t-color-bodyGrayA l-spacing45 t-line-h-22 font-r flex-grow-1 ">
							{{$t("1810", { str:totalElements})}}
						</div>
				</div>
				<div class="swiper-container main-swiper independent-survey-swiper pdb-6 pdx-4 mgt-30">
					<div class="d-grid-3-20 pda-4">
						<div v-for="(survey, index) in listData"
								:key="index" @click="moveDetail(survey.id)" @keypress="moveDetail(survey.id)" tabindex="0">
							<div class="mdc-card cursor-pointer" 
								>
										<!-- <div v-if="campaignData && parseInt(campaignData.locationValue) === index+1" class="mgt-16 mgb-16">
											<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
													<img :src="campaignData.image" alt="" />
											</a>
											<a v-else href="javascript:void(0)" style="cursor:none">
												<img :src="campaignData.image" alt="" />
											</a>
			</div>  -->
										
											<div class=" position-relative">
												<div class="pdl-24 pdr-24 pdt-24">
													<img v-if="survey && survey.image" :src="survey.image" :alt="survey.name" class="test-carousel-image">
													<img v-else src="/images/survey/no-carousel-image.png" alt="" class="test-carousel-image">
												</div>
												<div class="mdc-chip-set swiper-chip" role="grid">
													<div class="mdc-chip h-32 t-line-h-initial" role="row">
														<div class="mdc-chip__ripple"></div>
														<span role="gridcell">
															<span role="button"  class="mdc-chip__primary-action">
																<span
																	class="mdc-chip__text t-body3 pdt-4 pdb-4 t-color-white font-rn">{{index+1}}
																	/ {{listData.length}}</span>
															</span>
														</span>
													</div>
												</div>
											</div>
									
									<div class="pda-24">
											<div class="t-body4 font-r t-color-bodyGrayA l-spacing39">
													{{survey && survey.category?survey.category.text:''}}
											</div>
											<div class="pdt-4 t-headline7 font-m  t-line-h-24">
													{{survey?survey.name:''}}
											</div>
											<div class="pdt-16 t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-23">
												{{ displayPeriod(survey.application) }}
											</div>
											<div class="d-flex align-items-center pdt-2">
												<i class="material-icons t-color-iconInactive t-headline14 mgr-8">groups</i>
												<span class="t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-24">{{$t("1812", { str:survey.submitCount})}}</span>
											</div>
											<div class="mgt-14 t-body7 font-m l-spacing45 t-color-bodyBlueGray t-line-h-24" v-if="survey.progression.value === 'APPLICATION' || survey.progression.value === 'RESPONDENT' || survey.progression.value === 'RESPONDING'">
												{{$t('1813')}}
											</div>
											<div class="mgt-14 t-body7 font-m l-spacing45 t-color-bodyBlueGray t-line-h-24" v-else-if="survey.progression.value === 'SUBMITTED'">
												{{$t('1814')}}
											</div>
											<div class="mgt-14 t-body7 font-m l-spacing45 t-color-bodyBlueGray t-line-h-24" v-else-if="survey.progression.value === 'WAITING' || survey.progression.value === 'NONRESPONSE'">
												{{$t('1815')}}
											</div>
									</div>
							</div>
						</div>
					</div>
				</div>
			<infinite-loading @infinite="fetchData" spinner="spiral">
				<div slot="no-more" class="pdt-16 pdb-16"><!--No more data--></div>
				<div slot="no-results" class="pdt-16 pdb-16"></div>
			</infinite-loading>
		</div>
	</main>
</template>

<script>
	import surveyApi from "@/api/surveyApi.js";
	import campaignApi from "@/api/campaignApi.js";
	import { MDCRipple } from "@material/ripple";
	import NoData from "../../common/NoDataSurveyList.vue";
	import InfiniteLoading from "vue-infinite-loading";
	import TopAppBarSurveyListTab from "../../TopAppBarSurveyListTab.vue";
	import { utilDateMixin } from "@/mixins/dateUtil";

	export default {
		components: {   
			NoData,
			InfiniteLoading,
			TopAppBarSurveyListTab
		},

		mixins: [utilDateMixin],

		data() {
			return {
				isNoData: false,
				campaignData: null,
				listData: [],
				currentPage: 1,
				totalPages: 1,
				totalElements: 0
			};
		},

		mounted() {
		// 캠페인 테이터 API 호출(get campaign data)
		campaignApi
			.campaign({ locationType: "INDEPENDENT_SURVEY_LIST" })
			.then((response) => {
				this.campaignData = response.data.data;
			})
			.catch((err) => {});
		},
		methods: {
		// 목록 데이터 호출(get survey list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();

			if (this.totalPages >= this.currentPage) {
				surveyApi.myIndependentSurveyListResult(params).then((response) => {
					responseData = response.data.data;
					this.listData = this.listData.concat(responseData.content);
					this.currentPage++;
					this.totalPages = responseData.totalPages;
					this.totalElements = responseData.totalElements;

					if (responseData.content.length) {
						$state.loaded();
					} else {
						$state.complete();
					}
					if (!this.listData.length) {
						this.isNoData = true;
					}
				});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				page: this.currentPage,
				size: 10,
				sort: "id,desc",
			};
			return params;
		},

		// 상세로 이동(move view)
		moveDetail(id) {
			this.$router.push({
				name: "SurveyInsightView",
				params: { distId: id },
				query: this.$route.query,
			});
		},
	},
	}
</script>
